import {damsFetch} from "../../app/damsFetch";

const NOT_CLAIMED = [409, 404];

/**
 * Claims an incomplete upload job, so this tab may resurrect it (DE-1711, ADR-0006).
 *
 * The backend claims a job at most once: 200 when this call won, 409 when the job is already finished or
 * another tab claimed it first, 404 when the user does not own it.
 *
 * @param {string} jobId - The job to claim.
 * @returns {Promise<boolean>} True if this tab may resurrect the job.
 * @throws The rejection from damsFetch for any other failure.
 */
export const claimJob = async (jobId) => {
    try {
        const response = await damsFetch('/jobs/file-upload', {
            method: 'POST',
            body: JSON.stringify({action: 'claim', operation: {job_id: jobId}}),
        });
        return response?.claimed === true;
    } catch (status) {
        if (NOT_CLAIMED.includes(status)) {
            return false;
        }
        throw status;
    }
};
